/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";

/** @module core/modules/reg-exp-utils/replace */
import { normalize as arrayUtilsNormalize } from '../../array-utils/internals/normalize.js';
import { isPureObject } from '../../object-utils/internals/is-pure-object.js';
import { normalize } from './normalize.js';
/** @typedef {(string|RegExp|Array<(string|RegExp)>)} replaceRawExpType */

/**
 * @typedef replaceReplacerObjType
 * @property {replaceRawExpType} search - Expression representing string to be replaced.
 * @property {string} val - String to use as replacement.
 */

/** @typedef {(replaceReplacerObjType|Function)} replaceReplacerType */

/**
 * @description Makes replacements in input string in order based on replacer.
 * @param {string} str - Input string.
 * @param {(replaceReplacerType|Array<replaceReplacerType>)} replacer - Replacer to be used.
 * @returns {string} Resulting string.
 */

function replace(str, replacer) {
  var _context,
      _this = this,
      _context2;

  _forEachInstanceProperty(_context = arrayUtilsNormalize(replacer)).call(_context, _bindInstanceProperty(_context2 = function _context2(item) {
    var _this2 = this;

    _newArrowCheck(this, _this);

    if (typeof item === 'function') {
      str = item(str);
    } else if (isPureObject(item) && item.search && item.val) {
      var _context3, _context4;

      _forEachInstanceProperty(_context3 = normalize(item.search)).call(_context3, _bindInstanceProperty(_context4 = function _context4(regExp) {
        _newArrowCheck(this, _this2);

        str = str.replace(regExp, item.val);
      }).call(_context4, this));
    }
  }).call(_context2, this));

  return str;
}

export { replace };